import { defineMessages } from 'react-intl';

export const labels = defineMessages({
  paymentDateLabel: {
    defaultMessage: 'Payment Date',
    description: 'Payment Date label'
  },
  totalLabel: {
    defaultMessage: 'Total',
    description: 'total label'
  },
  printOrderLabel: {
    defaultMessage: 'Print Order',
    description: 'print order label'
  },
  printerNumberLabel: {
    defaultMessage: 'Printer No.',
    description: 'printer number label'
  },
  defaultPrinter: {
    defaultMessage: 'Default - 123',
    description: 'default printer value'
  },
  printOptions: {
    defaultMessage: 'Print Options',
    description: 'print options label'
  },
  checkLabel: {
    defaultMessage: 'Check',
    description: 'singular check'
  },
  checksLabel: {
    defaultMessage: 'Checks',
    description: 'plural check'
  },
  vendorLabel: {
    defaultMessage: 'Vendor Name',
    description: 'vendor name'
  },
  vendorNumber: {
    defaultMessage: 'Vendor No.',
    description: 'vendor number'
  },
  printSummarySheetLabel: {
    defaultMessage: 'Print Summary Sheet',
    description: 'print summary sheet label'
  },
  nextPrintChecks: {
    defaultMessage: 'Next: Print Checks',
    description: 'next print checks label'
  },
  dismiss: {
    defaultMessage: 'Dismiss',
    description: 'Dismiss'
  },
  printSummarySheetTitle: {
    defaultMessage: 'Account Payable Checks',
    description: 'print summary sheet title of the page'
  }
});

export const messages = defineMessages({
  postingDescription: {
    defaultMessage: 'Posting Description',
    description: 'Mandatory field Posting Description'
  },
  postingDescriptionErrorMessage: {
    defaultMessage: 'Posting Description is required',
    description: `Error message when postingDescription is empty`
  }
});
